module.exports = __webpack_public_path__ + "a10c7cf1a8cca266d3741005e1d7c371.MP3";